import React from 'react';
import { observer } from 'mobx-react-lite';
import { Button, DatePicker, Select, Space } from 'antd';
import { GroupType } from 'ts/constants/constants';
import {
  getCurrentMonthRange,
  getCurrentWeekRange,
  getLastMonthRange,
  getLastTwoWeeksRange,
  getLastWeekRange,
} from 'ts/helpers/getDefaultDate';
import globalStore from 'ts/store/Global';
import contributorsStore from 'ts/pages/ContributorsList/store/Contributors';
import { Dayjs } from 'dayjs';
import type { TimeRangePickerProps } from 'antd';

const CommitStatHeader = () => {

  const getRangePresets = (
    currentRange: [Dayjs | null, Dayjs | null] | null,
    currentPreset: string | null
  ): TimeRangePickerProps['presets'] => {
    const presets = [
      {
        label: 'Last 2 Weeks',
        value: getLastTwoWeeksRange(),
        key: 'last_two_weeks',
      },
      { label: 'Last Week', value: getLastWeekRange(), key: 'last_week' },
      { label: 'This Week', value: getCurrentWeekRange(), key: 'this_week' },
      { label: 'Last Month', value: getLastMonthRange(), key: 'last_month' },
      { label: 'This Month', value: getCurrentMonthRange(), key: 'this_month' },
    ];

    return presets.map((preset) => {
      const isActive = currentPreset === preset.key;

      return {
        label: (
          <Button
            style={{ width: '100%' }}
            type={isActive ? 'primary' : 'default'}
            onClick={() => globalStore.setPreset(preset.key)}
          >
            {preset.label}
          </Button>
        ),
        value: preset.value,
      };
    });
  };

  const employeeOptions = contributorsStore.contributorsList
    .filter((contributor) => {
      return contributor.group === GroupType.EMPLOYEE;
    })
    .map((contributor) => {
      return {
        label: contributor.name,
        value: contributor.id,
      };
    });

  const externalOptions = contributorsStore.contributorsList
    .filter((contributor) => {
      return contributor.group === GroupType.EXTERNAL;
    })
    .map((contributor) => {
      return {
        label: contributor.name,
        value: contributor.id,
      };
    });

  const groupedOptions = [
    {
      label: <span>{GroupType.EMPLOYEE}</span>,
      title: GroupType.EMPLOYEE,
      options: employeeOptions,
    },
    {
      label: <span>{GroupType.EXTERNAL}</span>,
      title: GroupType.EXTERNAL,
      options: externalOptions,
    },
  ];

  return (
    <Space>
          <Select
            style={{ width: '200px' }}
            showSearch
            optionFilterProp="label"
            placeholder="Search by Name"
            options={groupedOptions}
            filterOption={(input, option) => {
              return String(option?.label ?? '')
                .toLowerCase()
                .includes(input.toLowerCase());
            }}
            value={globalStore.contributorId}
            onChange={(id) => globalStore.setContributorId(id)}
          />
          <DatePicker.RangePicker
            presets={getRangePresets(
              globalStore.dateRange,
              globalStore.presetKey
            )}
            value={globalStore.dateRange}
            onChange={(dateRange) => globalStore.setDateRange(dateRange)}
          />
        </Space>
  );
};

export default observer(CommitStatHeader);
